export interface AuthData {
  token: string;
  refreshToken?: string;
  user?: string;
  company?: string;
}
